module.exports = __webpack_public_path__ + "img/aguas_sub_hover.fe00febb.png";